import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription, } from 'rxjs';
import * as fileSaver from 'file-saver';

import { FileDataService } from '../services/file-data.service';
import { SPLIT_WAYPOINT_OPTIONS } from '../../constants';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/user/services/auth.service';

//Interface / Enum's
import { IFileExtension, ICSVConfig } from './file-import';
import { IWayPoint } from '../itinenary-list/itinerary';
import { IItineraryRoute } from '../itinerary-route/itinerary-route';
import { IMapSettings } from '../../map-settings/settings';

//Dialogs
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { CsvConfigDialog } from './csv-config/csv-config.dialog';
import { SaveAsDialog } from './save-as/save-as.dialog';
import { TrackTypeDialog } from './track-type/track-type.dialog';
import { _MatCheckboxRequiredValidatorModule } from '@angular/material/checkbox';
import { SettingService } from '../../services/setting.service';
import { LoaderService } from 'src/app/services/loader.service';
import { MapSharedService } from '../services/map-shared.service';

@Component({
  selector: "app-file-import",
  templateUrl: "./file-import.component.html",
  styleUrls: ["./file-import.component.scss"],
})
export class FileImportComponent implements OnInit, OnDestroy {
  @ViewChild("fileImport") fileImport: ElementRef;

  fileResponseData = null;
  currentFileName: string = '';
  // currentUserName:any;
  selectedFileExportFormat: IFileExtension = {
    name: "TomTom Itinerary (.itn)",
    primaryFormat: ".itn",
    extension: [".itn"],
    isLink: false,
  };
  fileExportFormatList: IFileExtension[] = [];
  isCSV: boolean = false;
  csvData: ICSVConfig;

  // Subscription List
  subs: Subscription[] = [];
  // Waypoints displayed in ITINENARY TABLE (Always stores current data)
  displayedWaypoints: IWayPoint[] = [];
  url: string;

  //Itinerary-Route related variables
  isItineraryRoute: boolean = false;
  itineraryRouteData:any[] = [];
  userid: string = '';
  splitWaypointList = SPLIT_WAYPOINT_OPTIONS;
  selectedSplitWaypoint: any = SPLIT_WAYPOINT_OPTIONS[0];
  reloadFiledata: any;
  routeTime: any;
  // currentUserId :any;
  mapSetting: IMapSettings;
  constructor(
    private fileService: FileDataService,
    private csvDialog: MatDialog,
    private confirmDialog: MatDialog,
    private snackBar: MatSnackBar,
    private mapservice: SettingService,
    private loader: LoaderService,
    private authService: AuthService, 
    private router: Router,
    private sharedService: MapSharedService,
  ) { }

  ngOnInit() {
    this.getFileExtensions();
    // this.getAllLoginUsers();
   // this.getAllSavedFiles();
    this.onMapSettingsChanges();  

    this.subs.push(this.fileService.currentItinenary$.subscribe(
      (waypoints) => {
        this.displayedWaypoints = waypoints;
      }
    ));
    // Watch for changes if itineraryRoute to be fetched
    this.subs.push(this.fileService.isFetchRoute$.subscribe(
      (isRoute: boolean) => {
        this.isItineraryRoute = isRoute;
        // Trigger FILE IMPORT
        if (this.isItineraryRoute) {
          this.fileImport.nativeElement.click();
        }
      }
    ));

    this.subs.push(this.fileService.currentItineraryRouteData$.subscribe(
      (routeData: IItineraryRoute[]) => {
        this.itineraryRouteData = routeData;
      }
    ));

    this.subs.push(
      this.fileService.currentItineraryName$.subscribe(
        (name: string) => {
          if (name) {
            this.currentFileName = name;
          }
        })
    )
    // AUTO SAVE Code  
    this.reloadFiledata = this.fileService.tempRoutefile;
    const type = this.reloadFiledata.containsPolygon ? 'polygon' : 'route';
    this.handleFileImportData(this.reloadFiledata, type)
    this.fileService.isTempRoute = false;

    this.sharedService.setSaveStatus(null);

  }  //ngOnInit

  // // AUTO SAVE Code  Time Interval
  startTimeUp(count) {
    setInterval(() => {
      if (this.displayedWaypoints.length != 0) {
        this.openFileSaveAsDialog();
        this.loader.hide();
      }
    }, 60000 * count)
  }

  onMapSettingsChanges() {
    // Watch for any changes for `coordinate` type and `addWayPointPrompt` in MAP SETTINGS 
    this.subs.push(
      this.mapservice.currentMapSettings$.subscribe(
        (currentData: IMapSettings) => {
          if (currentData) {
            this.routeTime = currentData.selectedRouteInterval;
            this.startTimeUp(this.routeTime)
          }
        })
    );
  }

  // getAllSavedFiles() {
  //   this.fileService.getAllFiles().subscribe((data: any) => {
  //     for (let item of data.responseData) {
  //       var splitvalues = item.split("\\").pop();
  //       const foldername = splitvalues.split(".")[0];

  //     }
  //   })
  // }

  compareWithFileExtension(
    extension1: IFileExtension,
    extension2: IFileExtension
  ) {
    return extension1.name === extension2.name;
  }
  getFileExtensions() {
    this.fileService.getFileExtensions().subscribe(
      (res: any) => {
        if (res.responseStatus === "Success") {
          this.fileExportFormatList = res.responseData;
        }
      },
      (err) => console.log("Error while fetching file extensions: ", err)
    );
  }

  getFileDetails(event: any): void {
    
    const file: File = (event.target === undefined) ? event.valueOf(FileList)[0] : event.target.files[0];
    //#bug : empty the target value so that same filename can be imported twice
    if (event.target !== undefined) event.target.value = "";
    // CSV File Format Check
    this.isCSV = file && file.name.split(".")[1] === "csv" ? true : false;
    if (this.isCSV) {
      this.csvImportExport("Import").then(
        (res) => {
          this.csvData = res;
          this.uploadFileData(file);
        },
        (err) => {
          console.log("Unable to write CSV File");
        }
      );
    } else {
      this.uploadFileData(file);
    }
  }

  /**
   * Sends the file from browser to Server
   * Shares the parsed file data(recieved from backend) to fileService
   * @param files - File[]
   */
  uploadFileData(file: File): void {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);

    if (this.isCSV) {
      formData.append("csvSetting", JSON.stringify(this.csvData));
    }

    this.fileService.uploadFile(formData).subscribe(
      (res: any) => {
        if (res.responseStatus === "Success" &&
          res.responseData && (res.responseData.containsPolygon || res.responseData.containsRoute)
        ) {
          if (res.responseData.containsPolygon && res.responseData.containsRoute) {
            this.openDialog(res);
          } else {
            const type = res.responseData.containsPolygon ? 'polygon' : 'route';
            this.handleFileImportData(res, type);
          }
        } else {
          const errorMessage = res.responseMessage || 'Unable to parse the file';
          this.openSnackBar(errorMessage);
        }
      },
      (error) => console.log("Error while Uploading file: ", error)
    );
  }

  openDialog(res: any) {
    const fileName: string = this.currentFileName || 'Itinerary';
    const trackTypeDialog = this.csvDialog.open(TrackTypeDialog, {
      width: "30rem",
      disableClose: true,
    });

    trackTypeDialog.afterClosed().subscribe((result) => {
      if (result.saveData) {
        this.handleFileImportData(res, result.response.typeOptions);
      }
    });
  }

  handleFileImportData(res: any, type: string) {
    this.fileService.isFitSelectRoute = true;
    // Send data to `ITINERARY TABLE`
    this.reloadFiledata = res.responseData
    if (this.reloadFiledata != undefined) {
      if (!this.isItineraryRoute) {
        this.changeItineraryName(this.reloadFiledata.fileName);
        this.fileResponseData = this.reloadFiledata;
        const { wayPoints, polygonPoints } = this.fileResponseData;
        if (type === 'route' && (wayPoints || polygonPoints)) {
          this.fileService.changeItinenaryData(wayPoints, false);
        } else {
          this.fileService.changeItinenaryData(polygonPoints, false);
        }
        this.fileService.isDrawPolygon = (type === 'polygon' ? true : false);
      } else {
        // Send data to `ITINERARY ROUTE LIST`
        let wayPointsOrPolygonPoints: IWayPoint[]=[];
        if (type === 'polygon') {
          if (this.reloadFiledata.containsPolygon && this.reloadFiledata.containsMultiPolyLine) {
            wayPointsOrPolygonPoints = this.reloadFiledata.multiRoute;
          } else {
            wayPointsOrPolygonPoints = this.reloadFiledata.polygonPoints;
          }
        } else {
          wayPointsOrPolygonPoints = this.reloadFiledata.wayPoints;
        }

        const routeData: IItineraryRoute = {
          id: this.itineraryRouteData.length > 0 ? this.itineraryRouteData.length + 1 : 1,
          name: this.reloadFiledata.fileName,
          isPolygon: this.reloadFiledata.containsPolygon,
          multiRoute: this.reloadFiledata.containsMultiPolyLine,
          waypoints: wayPointsOrPolygonPoints
        };
        this.itineraryRouteData.push(routeData);
        this.fileService.changeItineraryRouteData(this.itineraryRouteData);
        this.fileService.addItineraryRoute(false);
      }
    }
  }
  getExportFileData(): void {
    if (this.selectedFileExportFormat.primaryFormat === ".csv") {
      this.csvImportExport("Export").then(
        (res) => {
          this.isCSV = true;
          this.csvData = res;
          this.openFileSaveAsDialog();
        },
        (err) => {
          console.log("Unable to write CSV File");
        }
      );
    } else {
      this.isCSV = false;
      this.openFileSaveAsDialog();
    }
  }

  openFileSaveAsDialog() {
    const fileName: string = this.currentFileName || 'Itinerary';
    var splitName = fileName.split("_")
    var name = "";
    splitName.forEach(element => {
      if (this.fileService.currentUserName.firstName != element) {
        name = name + element + "_";
      }
    });
    
    this.exportFile(this.fileService.currentUserName.firstName + "_" + name.substring(0, name.length - 1), this.selectedFileExportFormat.primaryFormat);
   
  }
  /**
   * Export the file with selected format
   */
  exportFile(fileName: string, extension: string): void {
    const payload = { ...this.fileResponseData };
    payload.exportTo = this.selectedFileExportFormat.name;
    payload.fileExtension = extension;
    payload.wayPoints = this.displayedWaypoints;
    payload.fileName = fileName.split(".")[0]; // Send fileName and extension in separate field
    payload.splitWayPointsBy = this.selectedSplitWaypoint.value;

    if (this.isCSV && this.csvData) {
      payload.csvFileSetting = this.csvData;
      payload.isCsv = true;
    }
    this.fileService.autoSaveFile(payload).subscribe((response) => {
       if (response.responseCode != null && response.responseCode.statusCode === 401) {
        this.sharedService.setSaveStatus('Failed'); // Set 'Failed' in case of error
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } else if (response.responseStatus == "Success" && response.responseData != null){
        //  this.generateAndDownloadFile(response.responseData);
        //  this.fileService.isItinerayChanged = false;
        const status = response.responseStatus === 'Success' ? 'Success' : 'Failed';
        this.sharedService.setSaveStatus(status); // Update the shared service with the status
      } else {
        // any error
        this.sharedService.setSaveStatus('Failed'); // Set 'Failed' in case of error
      }
    }),
      (error: any) => console.log("Error downloading the file", error),
      () => console.log("File downloaded successfully");
      this.sharedService.setSaveStatus('Failed'); // Set 'Failed' in case of error
  }

  generateAndDownloadFile(res: any) {
    const { multiFileContent, type, url, fileExtension, itfFileContent } = res;
    // Download the file based on 'type'
    if (type === "File") {
      for (const fileItem in multiFileContent) {
        const bytes = fileExtension === '.itf' ? this.byteArrayConversion(itfFileContent) : multiFileContent[fileItem];
        const blob: any = new Blob([bytes], {
          type: "application/octet-stream",
        });

        const file = new File([blob], `${fileItem}${fileExtension}`, {
          type: "application/octet-stream",
        });
        //fileSaver.saveAs(file);
       // fileSaver.saveAs(file,this.currentFileName,)
      }
    } else if (type === "Link") {
      window.open(url, "_blank");
    }
  }

  /**
   * Byte Array conversion wrt ITF file
   * @param fileContent
   */
  byteArrayConversion(fileContent: string) {
    const binaryString = window.atob(fileContent);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  /**
   * Open CSV Config dialog
   * Fetch User defined CSV config data
   * @param mode - Import or Export
   */
  async csvImportExport(mode: string): Promise<ICSVConfig> {
    return new Promise<ICSVConfig>((resolve, reject) => {
      const dialogRef = this.csvDialog.open(CsvConfigDialog, {
        width: "30rem",
        disableClose: true,
        data: mode,
      });

      dialogRef.afterClosed().subscribe((result) => {
        //Save the data if ONLY some data is passed via crudDialog
        if (result.saveData) {
          resolve(result.csvData);
        } else {
          reject();
        }
      });
    });
  }
  checkModifiedData() {
    this.fileService.writeLog("Import-start").subscribe((res:any)=> {
      if (res.responseCode != null && res.responseCode.statusCode === 401) {
        this.authService.logout();
        this.router.navigate(['/user/login']);
      } else {
        if (this.displayedWaypoints.length) {
          const message =
            "Changes will be lost. Continue anyway?";
          const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
            width: "28rem",
            data: message,
            disableClose: false,
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result.saveData) {
              this.fileService.isSelectedMarker = true;
              this.fileService.isDisableUTurn = false;
              this.fileImport.nativeElement.click();
            }
          });
        } else {
          this.fileImport.nativeElement.click();
        }
      }
    },
      (err) => console.log("Error while file import: ", err)
    );    
    // if (this.displayedWaypoints.length) {
    //   const message =
    //     "Changes will be lost. Continue anyway?";
    //   const dialogRef = this.confirmDialog.open(ConfirmDialogComponent, {
    //     width: "28rem",
    //     data: message,
    //     disableClose: false,
    //   });
    //   dialogRef.afterClosed().subscribe((result) => {
    //     if (result.saveData) {
    //       this.fileService.isSelectedMarker = true;
    //       this.fileService.isDisableUTurn = false;
    //       this.fileImport.nativeElement.click();
    //     }
    //   });
    // } else {
    //   this.fileImport.nativeElement.click();
    // }
  }
  openSnackBar(message: string) {
    this.snackBar.open(message, 'close', {
      duration: 10000,
      verticalPosition: 'top'
    });
  }
  /**
   * Helper function to update the current `ITINERARY NAME`
   * in both places(export section and ITN table)
   */
  changeItineraryName(name: string) {
    this.currentFileName = name;
    this.fileService.changeItineraryName(name);
  }

  ngOnDestroy(): void {
    this.subs.forEach(sub => sub.unsubscribe());
    this.reloadFiledata = "";
  }
}
